<div class="logos">
  <a href="https://www.voi.com/" target="_blank">
    <img ngSrc="../../../../assets/img/voi%20logo.svg" height="31" width="59">
  </a>
  <div style="display: flex; justify-content: center; align-items: center; gap: 4px;">
    <div class="with-label">with</div>
    <a href="https://signal-iduna.de/" target="_blank">
      <img ngSrc="../../../../assets/img/signal%20iduna%20logo.svg" height="16" width="86">
    </a>
  </div>
</div>
